var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8,
    cy: 5,
    rx: 6,
    ry: 3,
    stroke: "#898EA2",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6978 5.94263C13.451 6.31579 13.0616 6.65651 12.5619 6.94865C13.0656 7.33047 13.25 7.71034 13.25 7.99993C13.25 8.39124 12.9133 8.9474 11.9072 9.45043C10.946 9.93103 9.56567 10.2499 8 10.2499C6.43433 10.2499 5.05397 9.93103 4.09277 9.45043C3.08671 8.9474 2.75 8.39124 2.75 7.99993C2.75 7.71034 2.93441 7.33046 3.43806 6.94865C2.9384 6.6565 2.54903 6.31579 2.30221 5.94263C1.67947 6.4838 1.25 7.17322 1.25 7.99993C1.25 9.26548 2.25643 10.2093 3.42195 10.7921C4.63232 11.3973 6.25196 11.7499 8 11.7499C9.74804 11.7499 11.3677 11.3973 12.5781 10.7921C13.7436 10.2093 14.75 9.26548 14.75 7.99993C14.75 7.17322 14.3205 6.4838 13.6978 5.94263Z",
    fill: "#898EA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6978 8.94263C13.451 9.31579 13.0616 9.65651 12.5619 9.94865C13.0656 10.3305 13.25 10.7103 13.25 10.9999C13.25 11.3912 12.9133 11.9474 11.9072 12.4504C10.946 12.931 9.56567 13.2499 8 13.2499C6.43433 13.2499 5.05397 12.931 4.09277 12.4504C3.08671 11.9474 2.75 11.3912 2.75 10.9999C2.75 10.7103 2.93441 10.3305 3.43806 9.94865C2.9384 9.6565 2.54903 9.31579 2.30221 8.94263C1.67947 9.4838 1.25 10.1732 1.25 10.9999C1.25 12.2655 2.25643 13.2093 3.42195 13.7921C4.63232 14.3973 6.25196 14.7499 8 14.7499C9.74804 14.7499 11.3677 14.3973 12.5781 13.7921C13.7436 13.2093 14.75 12.2655 14.75 10.9999C14.75 10.1732 14.3205 9.4838 13.6978 8.94263Z",
    fill: "#898EA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.1e7d1d2313a198223b426e3d57351dd8.svg";
export { ForwardRef as ReactComponent };